export type Roles = 'learner' | 'trainer' | 'director' | 'manager' | 'administrator' ;
export type RolesOrDefault = Roles | 'default';
export enum RolesEnum {
    learner = 'learner',
    trainer = 'trainer',
    director = 'director',
    manager = 'manager',
    administrator = 'administrator'
}